/* Top Shot Players — limited-time pre-sale popup (Shopify newsletter signup) */
(function () {
  "use strict";

  var modal = document.getElementById("tsp-game-modal");
  if (!modal) return;

  var DISMISS_KEY = "tspGameDismissed";
  var STORE_KEY = "tspWin";
  var POPUP_DELAY = 3000;
  var CODE = modal.getAttribute("data-code") || "TSP30";
  var LABEL = modal.getAttribute("data-label") || "30% OFF";

  var form = document.getElementById("game-email-form");
  var emailInput = document.getElementById("game-email-input");
  var emailErr = document.getElementById("game-email-err");
  var consentInput = document.getElementById("game-consent-input");
  var consentErr = document.getElementById("game-consent-err");
  var successEl = document.getElementById("game-success");

  function storedWin() {
    try {
      var win = JSON.parse(localStorage.getItem(STORE_KEY) || "null");
      return win && win.code ? win : null;
    } catch (e) { return null; }
  }
  function saveWin() {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify({ code: CODE, label: LABEL }));
      window.dispatchEvent(new CustomEvent("tsp:win"));
    } catch (e) {}
  }

  function showSuccess() {
    if (form) form.hidden = true;
    if (successEl) successEl.hidden = false;
    var copyBtn = successEl ? successEl.querySelector("[data-copy]") : null;
    if (copyBtn && !copyBtn.dataset.bound) {
      copyBtn.dataset.bound = "1";
      copyBtn.addEventListener("click", function () {
        navigator.clipboard.writeText(copyBtn.getAttribute("data-copy")).then(function () {
          copyBtn.textContent = "Copied!";
        });
      });
    }
  }

  if (consentInput) {
    consentInput.addEventListener("change", function () {
      if (consentInput.checked) consentErr.classList.remove("show");
    });
  }

  if (form) {
    form.addEventListener("submit", function (e) {
      var email = (emailInput.value || "").trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
      var consented = consentInput.checked;
      if (!valid) {
        e.preventDefault();
        emailErr.classList.add("show");
        emailInput.focus();
        return;
      }
      if (!consented) {
        e.preventDefault();
        consentErr.classList.add("show");
        consentInput.focus();
        return;
      }
      /* Save the code client-side so the cart auto-applies it, then let the
         native Shopify customer form submit (registers the newsletter signup). */
      saveWin();
    });
  }

  function openModal() {
    if (!modal.hidden) return;
    if (storedWin()) showSuccess();
    modal.hidden = false;
    document.body.classList.add("game-modal-open");
    requestAnimationFrame(function () { modal.classList.add("show"); });
    if (!storedWin() && emailInput) {
      setTimeout(function () { emailInput.focus(); }, 250);
    }
  }

  function setDismissed() {
    try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch (e) {}
  }

  function closeModal() {
    if (modal.hidden) return;
    modal.classList.remove("show");
    document.body.classList.remove("game-modal-open");
    setDismissed();
    setTimeout(function () { modal.hidden = true; }, 250);
  }

  modal.addEventListener("click", function (e) {
    /* "Shop Now" navigates away — record the dismiss synchronously first so
       the popup never reappears for the rest of this session. */
    if (e.target.closest("[data-game-dismiss]")) {
      setDismissed();
      return;
    }
    if (e.target.closest("[data-game-close]")) closeModal();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !modal.hidden) closeModal();
  });
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-game-open]");
    if (!btn) return;
    e.preventDefault();
    openModal();
  });

  /* Returned from a successful Shopify customer signup → confirm + show code. */
  var posted = /[?&]customer_posted=true/.test(location.search) ||
    (successEl && !successEl.hidden);
  if (posted) {
    saveWin();
    showSuccess();
    openModal();
    return;
  }

  var dismissed = false;
  try { dismissed = sessionStorage.getItem(DISMISS_KEY) === "1"; } catch (e) {}
  if (!dismissed) {
    setTimeout(openModal, POPUP_DELAY);
  }
})();
